module.exports = __webpack_public_path__ + "static/media/UserDefault.ba56dd85.svg";